module.exports = __webpack_public_path__ + "static/media/app_store_button.d666e5d1.png";